import { useI18n } from '@muse/i18n'
import { type TTrySubscriptionEvents } from '@core/analytics'
import { useHydratedValue } from '@muse-web/router'
import { getSignUpUrl, ROUTES } from '@core/routes'
import { useShowTrySubscriptionButton } from '@features/subscription'
import { useHydratedCurrentUser } from '@features/session'

import { TryForFreeCard, type TTryForFreeCardVariant } from '../components/try-for-free-card'
import { sendTrySubscriptionClick } from '../helpers/sendTrySubscriptionClick'

export type TTryForFreeCardContainerProps = {
    event: TTrySubscriptionEvents
    variant?: TTryForFreeCardVariant
}

export const TryForFreeCardContainer = ({
    event,
    variant = 'large',
}: TTryForFreeCardContainerProps) => {
    const { t } = useI18n()
    const { id } = useHydratedCurrentUser()
    const showTryFree = useHydratedValue(useShowTrySubscriptionButton(), true)

    const isAuthenticated = id !== 0

    if (!showTryFree) {
        return null
    }

    const handleCtaClick = () => {
        sendTrySubscriptionClick(event)
    }

    return (
        <TryForFreeCard
            text={
                variant === 'large' ? t('i18n.tryForFreeTextLarge') : t('i18n.tryForFreeTextSmall')
            }
            ctaLabel={t('i18n.headerTryFree')}
            ctaHref={isAuthenticated ? ROUTES.subscriptions : getSignUpUrl()}
            variant={variant}
            onCtaClick={handleCtaClick}
        />
    )
}
